import { render } from "./BalToggle.vue?vue&type=template&id=b5c554da&scoped=true"
import script from "./BalToggle.vue?vue&type=script&lang=ts"
export * from "./BalToggle.vue?vue&type=script&lang=ts"

import "./BalToggle.vue?vue&type=style&index=0&id=b5c554da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b5c554da"

export default script